module.exports = __webpack_public_path__ + "static/media/addMemberGuide1.008f2e06.png";